import React from "react";
import { useAuth } from "../hooks/useAuth";
import { Form } from "react-final-form";
import Hidden from "@material-ui/core/Hidden";
import { Theme } from "@material-ui/core/styles";
import { Routes } from "../../../constants/routes";
import FormLink from "../../../components/FormLink";
import Typography from "@material-ui/core/Typography";
import TextDivider from "../../../components/TextDivider";
import { registerServiceProviderFormValidator } from "../utils/validators/registerForm";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { texts } from "../constants/texts";
import { useWizard } from "../../wizard/context";
import RegisterServiceProviderForm from "./forms/RegisterServiceProviderForm";
import { UserRole } from "../../user/enums/UserRole";

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    marginTop: 40,
  },
}));

export default function RegisterServiceProviderWidget() {
  const {
    actions: { register },
  } = useAuth();

  const { openWizard } = useWizard();

  const openModal = () => {
    openWizard({
      steps: [
        {
          titleConfig: {
            titleText: "OOPS.",
          },
          content: texts.warningMessage,
        },
      ],
      submitButtonText: "Ok",
      cancelButtonText: null,
    });
  };

  const classes = useStyles();

  function _submit(data) {
    const errors = registerServiceProviderFormValidator(data, openModal);

    if (
      Object.keys(errors).length > 1 ||
      Object.keys(errors.serviceProviderProfile.serviceProvider).length
    ) {
      return errors;
    }

    return register(data, UserRole.ServiceProvider);
  }

  return (
    <>
      <Form onSubmit={_submit} component={RegisterServiceProviderForm} />

      <Hidden mdUp>
        <div className={classes.footer}>
          <TextDivider text={"OR"} />
          <Typography component="p" align="center">
            Already Registered?{" "}
            <FormLink to={`/${Routes.LOGIN}`}>Sign In</FormLink>
          </Typography>
        </div>
      </Hidden>
    </>
  );
}
